// Reloj del workspace: fecha "de hoy" según la zona horaria configurada (Configuración → Zona horaria)
// y ajustada al reloj del servidor, para que una PC con hora/zona mal configurada no cambie el día o el mes.
export const DEFAULT_TZ = 'America/Mexico_City';
let timezone = DEFAULT_TZ;
let offsetMs = 0; // servidor − navegador
const listeners = new Set();

export const configureClock = ({ timezone: tz, serverNow } = {}) => {
  if (tz) timezone = tz;
  if (serverNow) {
    const t = Date.parse(serverNow);
    if (!Number.isNaN(t)) offsetMs = t - Date.now();
  }
  listeners.forEach((fn) => fn());
};
export const onClockChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };
export const getTimezone = () => timezone;
export const nowDate = () => new Date(Date.now() + offsetMs);

const partsCache = {};
const partsFormatter = (tz) => {
  if (!partsCache[tz]) partsCache[tz] = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
  return partsCache[tz];
};

// { year, month (0-11), day, hour, minute } en la zona del workspace
export const localParts = (date = nowDate(), tz = timezone) => {
  const p = {};
  for (const { type, value } of partsFormatter(tz).formatToParts(date)) p[type] = value;
  return { year: Number(p.year), month: Number(p.month) - 1, day: Number(p.day), hour: Number(p.hour) % 24, minute: Number(p.minute) };
};
const pad = (n) => String(n).padStart(2, '0');
export const todayLocal = () => { const { year, month, day } = localParts(); return `${year}-${pad(month + 1)}-${pad(day)}`; };
export const currentMonth = () => { const { year, month } = localParts(); return `${year}-${pad(month + 1)}`; };
// Date a medianoche local del navegador para el día de hoy del workspace (comparable con parseLocalDate)
export const todayDate = () => { const { year, month, day } = localParts(); return new Date(year, month, day); };
export const formatNow = (opts = {}) => nowDate().toLocaleDateString('es-MX', { timeZone: timezone, ...opts });
export const formatNowStamp = (opts = {}) => nowDate().toLocaleString('es-MX', { timeZone: timezone, ...opts });
